// components/forms/SymptomsForm.js
import React from 'react';

function SymptomsForm({ data, setData }) {
    const handleChange = (field, value) => {
        setData({
            ...data,
            [field]: value
        });
    };

    return (
        <div className="space-y-4">
            <h2 className="text-xl font-bold mb-4">主要症状</h2>

            <div className="grid grid-cols-1 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">最先出现的症状</label>
                    <input
                        type="text"
                        className="w-full p-2 border rounded"
                        placeholder="例如：言语不清、肢体无力等"
                        value={data.firstSymptom}
                        onChange={(e) => handleChange('firstSymptom', e.target.value)}
                    />
                </div>

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="facialAsymmetry"
                        className="mr-2"
                        checked={data.facialAsymmetry}
                        onChange={(e) => handleChange('facialAsymmetry', e.target.checked)}
                    />
                    <label htmlFor="facialAsymmetry" className="text-sm font-medium text-gray-700">面部不对称或下垂</label>
                </div>

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="limbWeakness"
                        className="mr-2"
                        checked={data.limbWeakness}
                        onChange={(e) => handleChange('limbWeakness', e.target.checked)}
                    />
                    <label htmlFor="limbWeakness" className="text-sm font-medium text-gray-700">肢体无力或麻木</label>
                </div>

                {data.limbWeakness && (
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">肢体无力侧别</label>
                        <select
                            className="w-full p-2 border rounded"
                            value={data.limbWeaknessSide}
                            onChange={(e) => handleChange('limbWeaknessSide', e.target.value)}
                        >
                            <option value="右侧">右侧</option>
                            <option value="左侧">左侧</option>
                            <option value="双侧">双侧</option>
                        </select>
                    </div>
                )}

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="speechIssues"
                        className="mr-2"
                        checked={data.speechIssues}
                        onChange={(e) => handleChange('speechIssues', e.target.checked)}
                    />
                    <label htmlFor="speechIssues" className="text-sm font-medium text-gray-700">言语不清或理解障碍</label>
                </div>

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="visionProblems"
                        className="mr-2"
                        checked={data.visionProblems}
                        onChange={(e) => handleChange('visionProblems', e.target.checked)}
                    />
                    <label htmlFor="visionProblems" className="text-sm font-medium text-gray-700">视力问题（模糊、复视或单眼失明）</label>
                </div>

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="dizziness"
                        className="mr-2"
                        checked={data.dizziness}
                        onChange={(e) => handleChange('dizziness', e.target.checked)}
                    />
                    <label htmlFor="dizziness" className="text-sm font-medium text-gray-700">头晕或平衡问题</label>
                </div>

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="headache"
                        className="mr-2"
                        checked={data.headache}
                        onChange={(e) => handleChange('headache', e.target.checked)}
                    />
                    <label htmlFor="headache" className="text-sm font-medium text-gray-700">严重头痛</label>
                </div>

                {data.headache && (
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">头痛程度</label>
                        <select
                            className="w-full p-2 border rounded"
                            value={data.headacheSeverity}
                            onChange={(e) => handleChange('headacheSeverity', e.target.value)}
                        >
                            <option value="">请选择</option>
                            <option value="轻度">轻度</option>
                            <option value="中度">中度</option>
                            <option value="重度">重度</option>
                            <option value="剧烈">剧烈</option>
                        </select>
                    </div>
                )}

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">症状发生方式</label>
                    <select
                        className="w-full p-2 border rounded"
                        value={data.onsetType}
                        onChange={(e) => handleChange('onsetType', e.target.value)}
                    >
                        <option value="突然发生">突然发生</option>
                        <option value="逐渐加重">逐渐加重</option>
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">症状进展情况</label>
                    <select
                        className="w-full p-2 border rounded"
                        value={data.symptomProgression}
                        onChange={(e) => handleChange('symptomProgression', e.target.value)}
                    >
                        <option value="">请选择</option>
                        <option value="无明显变化">无明显变化</option>
                        <option value="逐渐好转">逐渐好转</option>
                        <option value="逐渐加重">逐渐加重</option>
                        <option value="波动性变化">波动性变化</option>
                    </select>
                </div>
            </div>
        </div>
    );
}

export default SymptomsForm;